
import { butter } from "~/plugins/buttercms";
import {
  invokeShopifyQuery,
  itemFilterWithActive,
  itemFilterWithGreets,
  itemfilterWithCharity,
  GIFT_ADDS,
  VASE,
  GREET_NAME,
  GREET,
} from "@/utils/shopify";
import ProductMapMixin from "~/mixin/product-map-mixin";
import ShopifyProduct from "~/types/shopify/ShopifyProduct";
import DeliveryWeekMixin from "~/mixin/delivery-week-mixin";
import FormatMixin from "~/mixin/format-mixin";
import Addon from "~/types/cms/Addon";
import Meta from "~/types/cms/Meta";
import ProcessLineItemsMixin from "~/mixin/process-lineitems-mixin";

const datadogErrorUrl = "datadog/events/error";

export default {
  name: "cal-complete-bouquet",
  props: {
    workflow: {
      type: String,
      required: false,
    },
    config: {
      type: Object,
      required: false,
    },
    isLoadAddons: {
      type: Boolean,
    },
  },
  computed: {
    selectedAddons(): any {
      return this.selectedAddonsUpdated || this.$store.state.cartItem.addons;
    },
    selectedVase(): any {
      return this.selectedVaseUpdated || [this.$store.state.cartItem.vase];
    },
    selectedGreet(): any {
      return this.selectedGreetUpdated || [this.$store.state.cartItem.greet];
    },
    selectedDonations(): any {
      return (
        this.selectedDonationUpdated || this.$store.state.cartItem.donations
      );
    },
  },
  watch: {
    async isLoadAddons() {
      await this.loadAddons();
    },
  },
  data() {
    return {
      showReadMore: false,
      readMoreAddon: {},
      addOnsCMS: [] as Addon[],
      addOns: [] as any[],
      vases: [] as any[],
      greets: [] as any[],
      donations: [] as any[],
      // selectedAddons: { ...this.$store.state.cartItem.addons },
      // selectedVase: { ...this.$store.state.cartItem.vase },
      //selectedGreet: { ...this.$store.state.cartItem.greet },
      selectedGreetUpdated: null,
      selectedVaseUpdated: null,
      selectedAddonsUpdated: null,
      selectedDonationUpdated: null,
      showModal: false,
      showGreets: false,
      isGreetsSelected: false,
      showVases: true as boolean,
      showAddons: true as boolean,
    };
  },
  async created() {
    if (this.workflow == "SUBSCRIPTION") {
      await this.loadAddons();
      this.$nuxt.$emit("disableContinueSubs", false);
    } else {
      this.$nuxt.$emit("disableContinue", false);
    }
    if (this.config?.autoSelectGreets) {
      this.showGreets = true;
    }
    // Can remove this after figuring out wht this watcher is not working
    if (sessionStorage.deliveryDate) {
      await this.loadAddons();
    }
  },
  mixins: [
    ProductMapMixin,
    DeliveryWeekMixin,
    FormatMixin,
    ProcessLineItemsMixin,
  ],
  methods: {
    generateOccasionTag(occasion) {
      let tag = occasion.trim().replace(/ /g, "-");
      return `occasion:${tag.toLowerCase()}`;
    },
    handleShowReadMore(addon) {
      this.readMoreAddon = addon;
      this.showReadMore = true;
    },
    async getAddonsContent() {
      try {
        const response = await butter(this.$config).content.retrieve(
          ["addons"],
          {
            locale: this.$i18n.locale,
            "fields.type1": "common",
          }
        );
        this.addOnsCMS = this.mapCMSAddons(response);
      } catch (error) {
        console.error(error);
      }
    },
    async processAddons(products: ShopifyProduct[], productType: string) {

      const bouquetProductTags = this.$store.state.cartItem.product?.tags || [];
      let occasion = sessionStorage['occasion'];

      const occasionsTag = occasion && occasion?.length > 0
        ? this.generateOccasionTag(occasion)
        : "gift-adds";

      const deliveryWeekTag = this.selectWeekNumber(this.getDeliveryDate());
      const isRelevantOccasion = (tags) =>
        tags.includes(occasionsTag) || tags.includes("occasion:all");

      const processedAddons = products
        .filter((product) => {
          const { tags } = product;
          return (
            tags.includes("gift-adds") &&
            tags.includes("active") &&
            tags.includes(deliveryWeekTag) &&
            productType === GIFT_ADDS &&
            isRelevantOccasion(tags)
            && !bouquetProductTags.includes(`hide:${product.title}`)
          );
        })
        .map((product) => {
          const variant = product.productVariants?.[0] || {};
          const salePrice = Number(variant.compareAtPriceV2?.amount || 0);
          const price = Number(variant.price?.amount || 0);

          return {
            src: this.getImages(
              product.title || "",
              productType,
              this.addOnsCMS
            ),
            id: variant.id,
            tags: product.tags,
            orderSequenceNumber: this.getOrderSequenceNumber(product.tags),
            sku: variant.sku,
            variant,
            title: product.title,
            titleView: this.getUserViewName(
              product.title || "",
              productType,
              this.addOnsCMS
            ),
            priceCompare: salePrice,
            price: salePrice > 0 ? salePrice : price,
            priceView: salePrice > 0 ? salePrice : price,
            salePrice: salePrice > 0 ? price : undefined,
            comparePriceView: salePrice,
            description: this.getUserViewDescription(
              product.title || "",
              productType,
              this.addOnsCMS
            ),
          };
        });

      return this.splitAndSort(processedAddons);
    },
    async processVases(products: ShopifyProduct[], productType: string) {

      const bouquetProductTags = this.$store.state.cartItem.product?.tags || [];
      let occasion = sessionStorage['occasion'];

      const occasionsTag = occasion && occasion?.length > 0
        ? this.generateOccasionTag(occasion)
        : "vase";

      const deliveryWeekTag = this.selectWeekNumber(this.getDeliveryDate());
      const isOccasionRelevant = (tags) =>
        tags.includes(occasionsTag) || tags.includes("occasion:all");
      const isWeekRelevant = (tags) =>
        tags.includes(deliveryWeekTag) || tags.includes("vase-ongoing");
      const isWeekExcluded = (tags) => tags.includes(`not-${deliveryWeekTag}`);

      const processedVases = products
        .filter((product) => {
          const { tags } = product;
          return (
            tags.includes("vase") &&
            tags.includes("active") &&
            isOccasionRelevant(tags) &&
            isWeekRelevant(tags) &&
            !isWeekExcluded(tags) &&
            productType === VASE
            && !bouquetProductTags.includes(`hide:${product.title}`)
          );
        })
        .map((product) => {
          const variant = product.productVariants?.[0] || {};
          const salePrice = Number(variant.compareAtPriceV2?.amount || 0);
          const price = Number(variant.price?.amount || 0);

          return {
            src: this.getImages(
              product.title || "",
              productType,
              this.addOnsCMS
            ),
            id: variant.id,
            tags: product.tags,
            sku: variant.sku,
            variant,
            title: product.title,
            titleView: this.getUserViewName(
              product.title || "",
              productType,
              this.addOnsCMS
            ),
            comparePriceView: salePrice,
            description: product.description,
            priceCompare: salePrice,
            price: salePrice > 0 ? salePrice : price,
            priceView: salePrice > 0 ? salePrice : price,
            salePrice: salePrice > 0 ? price : undefined,
          };
        });

      return this.splitAndSort(processedVases);
    },
    async processGreets(product: ShopifyProduct[], productType: string) {
      const processedGreets = product
        .filter((product) => product.title == GREET_NAME)
        .map((product) => {
          return {
            src: this.getImages(
              product.title || "",
              productType,
              this.addOnsCMS
            ),
            id: (product.productVariants[0] || {}).id,
            tags: product.tags,
            sku: (product.productVariants[0] || {}).sku,
            variant: product.productVariants[0],
            title: product.title,
            titleView: this.getUserViewName(
              product.title || "",
              productType,
              this.addOnsCMS
            ),
            priceView: Number(
              (((product || {}).priceRange || {}).maxVariantPrice || {}).amount
            ),
            priceCompare: (
              ((product || {}).variant || {}).compareAtPriceV2 || {}
            ).amount,
            price: Number(
              (((product || {}).priceRange || {}).maxVariantPrice || {}).amount
            ),
            description: product.description,
          };
        });
      return processedGreets;
    },
    async processDonations(products: ShopifyProduct[], productType: string) {
      const processedDonations = products
        .filter(
          (product) =>
            product.tags.includes("gift-adds") &&
            product.tags.includes(
              this.selectWeekNumber(this.getDeliveryDate())
            ) &&
            product.tags.includes("charity") &&
            !product.tags.includes(
              "not-" + this.selectWeekNumber(this.getDeliveryDate())
            ) &&
            productType == GIFT_ADDS
        )
        .map((product) => {
          return {
            src: this.getImages(
              product.title || "",
              productType,
              this.addOnsCMS
            ),
            id: (product.productVariants[0] || {}).id,
            tags: product.tags,
            sku: (product.productVariants[0] || {}).sku,
            variant: product.productVariants[0],
            title: product.title,
            titleView: this.getUserViewName(
              product.title || "",
              productType,
              this.addOnsCMS
            ),
            price: Math.trunc(
              Number(
                ((product || {}).productVariants[0] || {}).price?.amount || {}
              )
            ),
            priceView: Number(
              ((product || {}).productVariants[0] || {}).price?.amount || {}
            ),
            description: product.description,
          };
        });
      return processedDonations;
    },
    getImages(title: string, productType: string, cmsData: Addon[]) {
      const cmsProduct = cmsData.filter((product) =>
        product.productName.includes(title)
      )[0];
      return cmsProduct ? cmsProduct.image : "";
    },
    getOrderSequenceNumber(tags: string[]) {
      //TODO:: need refactor
      let seqNum = 100;
      if (tags.length > 0 && tags.includes("order-sequence")) {
        tags.forEach((tag) => {
          if (tag.includes("sequence-number")) {
            seqNum = parseInt(tag.split("-")[2]);
          }
        });
      }
      return seqNum;
    },
    getUserViewName(title: string, productType: string, cmsData: Addon[]) {
      const cmsProduct = cmsData.filter(
        (product) => product.productName == title
      )[0];
      return cmsProduct ? cmsProduct.displayName : "";
    },
    getUserViewDescription(
      title: string,
      productType: string,
      cmsData: Addon[]
    ) {
      const cmsProduct = cmsData.filter(
        (product) => product.productName == title
      )[0];
      return cmsProduct ? cmsProduct.shortDescription : "";
    },
    onAddonUpdate(addon: any) {
      addon["productType"] = GIFT_ADDS;
      if (addon.quantity == 0) {
        this.$store.dispatch("cartItem/ADDON_REMOVE", addon);
      } else {
        this.$store.dispatch("cartItem/ADDON_UPDATE", addon);
      }
      this.$nuxt.$emit("addonUpdated", addon);
    },
    onVaseSelect(vase: any) {
      vase["productType"] = VASE;
      if (vase.quantity == 0) {
        this.$store.dispatch("cartItem/VASE_REMOVE", vase);
        this.selectedVaseUpdated = [];
      } else {
        this.$store.dispatch("cartItem/VASE_ADD", vase);
        this.selectedVaseUpdated = [{ ...vase }];
      }
      this.$nuxt.$emit("vaseUpdated", vase);
    },
    onDonationUpdate(donation: any) {
      donation["productType"] = GIFT_ADDS;
      if (donation.quantity == 0) {
        this.$store.dispatch("cartItem/DONATIONS_REMOVE", donation);
      } else {
        this.$store.dispatch("cartItem/DONATIONS_UPDATE", donation);
      }
    },
    onGreetSelect(greet: any) {
      this.isGreetsSelected = !this.isGreetsSelected;
      greet["productType"] = GREET;
      if (greet.quantity == 0) {
        this.$store.dispatch("cartItem/GREET_REMOVE", greet);
      } else {
        this.$store.dispatch("cartItem/GREET_ADD", greet);
      }
    },
    toggleModal() {
      this.showModal = !this.showModal;
    },
    isObjectNotEmpty(obj: any) {
      return Object.keys(obj).length > 0;
    },
    getPrice(price: Number) {
      return this.getPriceWithLocale(price);
    },
    getAddons(regionShortCode: string) {
      return (async () => {
        try {
          const selectedVariant = this.$store.state.cartItem.product;
          if (selectedVariant) {
            this.showAddons = !selectedVariant.tags.includes("NoAddons");


            if (this.showAddons) {
              if (this.workflow == "NON_FLORAL") {
                const { data } = await invokeShopifyQuery(
                  itemFilterWithActive("TR", GIFT_ADDS)
                );
                this.addOns = await this.processAddons(
                  this.mapShopifyProducts(data),
                  GIFT_ADDS
                );
              } else {
                const { data } = await invokeShopifyQuery(
                  itemFilterWithActive(regionShortCode, GIFT_ADDS)
                );
                this.addOns = await this.processAddons(
                  this.mapShopifyProducts(data),
                  GIFT_ADDS
                );
              }

              // Remove the flower food addon from the addons when selected product include 'Everlasting' tag
              const cartItem = this.$store.state.cartItem;

              if (cartItem?.product?.tags?.includes("Everlasting")) {
                const addonIndex = this.addOns.findIndex((addon) =>
                  addon.sku?.includes("flower-food")
                );
                if (addonIndex !== -1) {
                  this.addOns.splice(addonIndex, 1);
                }
              }
            }
          }
        } catch (err) {
          console.error(err);
          await this.$axios.$post(
            datadogErrorUrl,
            {
              error: {
                name: "ADDONS-NOT-FOUND",
                ddSessionId: this.getatadogSessionID(),
              },
            },
            {}
          );
        }
      })();

      // promises.push(promise);
    },
    getVases(regionShortCode: string) {
      return (async () => {
        try {
          // Add specific logic to hide the vases for some variants
          const selectedVariant = this.$store.state.cartItem.product;
          if (selectedVariant) {
            const regex = /[^a-zA-Z0-9]/g;
            // replace all special characters with space
            const vasesDisplayTagWithSpaces = selectedVariant.displayTitle
              .trim()
              .replace(regex, " ")
              .toLowerCase();
            // replace multiple or single space with a '-' special character
            const vasesDisplayTag = `${vasesDisplayTagWithSpaces.replace(
              /\s+/g,
              "-"
            )}-no-vase`;
            this.showVases =
              !selectedVariant.tags.includes(vasesDisplayTag) ||
              !selectedVariant.tags.include("NoVase");

            if (this.showVases) {
              const { data } = await invokeShopifyQuery(
                itemFilterWithActive(regionShortCode, VASE)
              );
              this.vases = await this.processVases(
                this.mapShopifyProducts(data),
                VASE
              );

              // Select the specific vase according to the tag
              const productName = selectedVariant.sku
                ? `default-product:${selectedVariant.sku.split("_")[0]}`
                : "default-product";
              const resultIndex = this.vases.findIndex((vase) =>
                vase.tags.includes(productName)
              );
              if (resultIndex > -1) {
                this.defaultSelectAVase(this.vases[resultIndex], resultIndex);
              }

              // Remove surprise me vase for grand variant
              if (this.$store.state.cartItem.product?.title === "Grand") {
                this.vases = this.vases.filter(
                  (item) => item.title !== "Surprise Me"
                );
              }
            }
          }
        } catch (err) {
          console.error(err);
          await this.$axios.$post(
            datadogErrorUrl,
            {
              error: {
                name: "VASES-NOT-FOUND",
                ddSessionId: this.getatadogSessionID(),
              },
            },
            {}
          );
        }
      })();
    },
    getDonations(regionShortCode: string) {
      return (async () => {
        const { data } = await invokeShopifyQuery(
          itemfilterWithCharity(regionShortCode, GIFT_ADDS)
        );
        this.donations = await this.processDonations(
          this.mapShopifyProducts(data),
          GIFT_ADDS
        );
      })();
    },
    getGreets() {
      return (async () => {
        const { data } = await invokeShopifyQuery(itemFilterWithGreets());
        this.greets = await this.processGreets(
          this.mapShopifyProducts(data),
          GIFT_ADDS
        );
      })();
    },
    async loadAddons() {
      try {
        const region = this.getRegion().regionShortCode;

        await this.getAddonsContent();

        const promises = [];

        if (this.config?.displayAddons) {
          const promise = this.getAddons(region);
          promises.push(promise);
        }

        if (this.config?.displayVases) {
          const promise = this.getVases(region);
          promises.push(promise);
        }

        if (this.config?.displayDonation) {
          const promise = this.getDonations(region);
          promises.push(promise);
        }
        if (this.config?.displayGreets) {
          const promise = this.getGreets();
          promises.push(promise);
        }
        // Use Promise.all to execute multiple API calls in parallel. which can reduce the overall execution time
        await Promise.all(promises);

        if (this.isObjectNotEmpty(this.$store.state.cartItem.greet)) {
          this.selectedGreetUpdated = [this.$store.state.cartItem.greet];
        }

        if (this.isObjectNotEmpty(this.$store.state.cartItem.vase)) {
          this.selectedVaseUpdated = [this.$store.state.cartItem.vase];
        }

        if (this.isObjectNotEmpty(this.$store.state.cartItem.addons)) {
          this.selectedAddonsUpdated = { ...this.$store.state.cartItem.addons };
        }

        if (this.isObjectNotEmpty(this.$store.state.cartItem.donations)) {
          this.selectedDonationUpdated = {
            ...this.$store.state.cartItem.donations,
          };
        }
      } catch (error) {
        console.error(error);
      }
    },
    defaultSelectAVase(vase, index) {
      let selectedVase = {
        quantity: 1,
        title: vase.title,
        index: index,
        addon: vase,
        productType: "Vase",
      };
      this.$store.dispatch("cartItem/VASE_ADD", selectedVase);
      this.selectedVaseUpdated = [{ ...selectedVase }];
    },
  },
};
